import { render } from "./UserList.vue?vue&type=template&id=28cb4625&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"

import "./UserList.vue?vue&type=style&index=0&id=28cb4625&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28cb4625"

export default script